export default __webpack_public_path__ + "e8e4ca59c0378d770be3544107f4eec6.svg";